<div class="wb-expanded-search-wrapper">
    @if(!activeSearch) {

    <div class="search-multiple-dialog-wrapper">
        <div class="search-multiple-content">
            <h4>Add PM# separated by commas</h4>
            <textarea (input)="searchInput = $event.target.value" [value]="searchInput"  placeholder="Add multiple PM#"></textarea>
        </div>
        
    </div>
    }
    @if(activeSearch) {
        <mat-spinner [diameter]="50"></mat-spinner>
        Searching ...
    }
    <div class="dialog-actions">
        <button mat-raised-button color="warn" (click)="close()">Cancel</button>
        @if(!activeSearch) {
        <button mat-raised-button color="primary" (click)="search()">Search</button>
        }
    </div>
    
</div>
